import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

function Modal({ isOpen, onClose, children, title, contentClassName = '' }) {
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [isOpen]);

    if (!isOpen) return null;


    const container = document.getElementById('modal-container');
    if (!container) {
        console.error('Modal container element not found: #modal-container');
        return null;
    }
    
    const modalContent = (
        <div className="modal">
            <div className="modal-overlay">
                <div className={`modal-content scrollable${contentClassName ? ` ${contentClassName}` : ''}`}>
                    <div className="navigation-buttons">
                        <h2>{title}</h2>
                        <button className="cancel-button" onClick={onClose}>
                            ×
                        </button>
                    </div>
                    <div className="modal-inner-content">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );


    return createPortal(modalContent, container);
}

export default Modal;